import classnames from 'classnames';
import { Card } from 'antd';
import classes from './index.module.scss';

import type { CardProps } from 'antd';

interface ICustomCardProps extends CardProps {
  className?: string;
}

const CustomCard = (props: ICustomCardProps) => {
  const { className, bordered = false, ...rest } = props;

  return (
    <Card
      className={classnames(
        classes.wrap,
        {
          [classes.borderless]: !bordered,
        },
        className
      )}
      bordered={bordered}
      {...rest}
    />
  );
};

export default CustomCard;
